import * as React from "react";
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import ImageRadioPicker from "../components/ImageRadioPicker";
import {Luiksluiting} from "../Model";
import typeAImage from '../images/luiksluitingA.jpg'
import typeDImage from '../images/luiksluitingD.jpg'
import macoImage from '../images/luiksluitingMaco.jpg'
import geenLuiksluitingImage from '../images/geen luiksluiting.jpg'
import traditioneelImage from '../images/luiksluitingTraditionel.jpg'
import oudhollandsImage from '../images/luiksluitingOudhollands.jpg'

export default class ClosingPick extends React.Component {
    render() {
        return (
            <div className="page">
                <AppHeader title="Luiksluiting"/>

                <div className="page-middle">
                    <h1 className="pick-title">Welke luiksluiting moet deze situatie krijgen?</h1>

                    <div className="pick-body scrollable">
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luiksluiting.TYPE_A}
                                          image={typeAImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luiksluiting.TYPE_D}
                                          image={typeDImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luiksluiting.MACO}
                                          image={macoImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luiksluiting.TRADITIONEEL}
                                          image={traditioneelImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luiksluiting.OUDHOLLANDS}
                                          image={oudhollandsImage}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={Luiksluiting.NO_CLOSING}
                                          image={geenLuiksluitingImage}/>
                    </div>
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           enableNext={this.props.currentValue}/>
            </div>
        );
    }
}